import { cn } from '@Pages/pageRuntime/lib/utils';

export function emptyStateClass(className: string | undefined): string {
  return cn(
    'flex items-center justify-center rounded-lg border-2 border-dashed border-border bg-muted p-8 text-sm text-muted-foreground',
    className
  );
}
